import type { Column } from '@rundown-studio/types'

/**
 * Filters and returns allowed columns based on their visibility and user permissions.
 *
 * @param {Column[]} columns - The array of rundown columns to filter.
 * @param {string} [userUid] - The UID of the user to check permissions against. Optional parameter.
 * @returns {Column[]} An array of columns that are either public or associated with the specified user UID.
 */
export const getAllowedColumns = (columns: Column[], userUid?: string) => {
  return columns.filter((column) => {
    // This is not a private column - it is allowed
    if (!column.privateUid) return true

    return column.privateUid === userUid
  })
}
